import { useState } from 'react'
import s from './GenerateProposal.scss'
import { AllDashboardComponent } from '../DictionaryDashboard'
import { GenerateProposalModal } from 'components/common/modals/GenerateProposal/GenerateProposalModal'
import { ProgressModal } from 'components/common/modals/GenerateProposal/ProgressModal'
import { FaFilePowerpoint } from 'react-icons/fa'

const GenerateProposal = ({ type, layoutLocked }) => {
  const [isGenerateProposalModalVisible, setIsGenerateProposalVisible] = useState(false)
  const [isProgressModalVisible, setIsProgressModalVisible] = useState(false)
  const [loadingStep, setLoadingStep] = useState('')
  return (
    <>
      <div
        onClick={layoutLocked ? () => setIsGenerateProposalVisible(true) : null}
        className={s.wrapper}
      >
        <>
          <FaFilePowerpoint className={s.icon} />
          <div>
            <h6>{AllDashboardComponent[type].label}</h6>
            <p>
              Quickly create proposals from hundreds of pre-designed templates. Simply select a
              template that matches your brand, input project data, and generate. Your proposal PDF
              will be ready to download and send to your client.
            </p>
          </div>
          <div className={s.action}>{'Create Proposal'.toUpperCase()}</div>
        </>
      </div>
      {isGenerateProposalModalVisible && (
        <GenerateProposalModal
          isGenerateProposalModalVisible={isGenerateProposalModalVisible}
          setIsGenerateProposalVisible={setIsGenerateProposalVisible}
          setIsProgressModalVisible={setIsProgressModalVisible}
          setLoadingStep={setLoadingStep}
        />
      )}
      {isProgressModalVisible && (
        <ProgressModal loadingStep={loadingStep} isProgressModalVisible={isProgressModalVisible} />
      )}
    </>
  )
}

export default GenerateProposal
